import { mapRecordFromServer, mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, GetOneResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IPart, IPartAutocomplete } from 'partsOld/types';

export const getManyAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IPartAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/parts/index/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IPartAutocomplete>(data.parts, data.total_count);
};

export const getOne = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IPart>> => {
  const { data } = await partfinitiClient.get(
    `/search/part?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordFromServer<IPart>(data.data);
};
